<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 棋盘系统 
                </el-breadcrumb-item>
				<el-breadcrumb-item>棋派管理</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
				<el-input v-model="query.name" placeholder="公司名称" class="handle-input mr10"></el-input>
				<el-select v-model="query.coreSect" placeholder="是否重点棋派" style="width:200px">
					<el-option key="" label="是否重点棋派" value=""></el-option>
					<el-option key=true label="是" value=true></el-option>
					<el-option key=false label="否" value=false></el-option>
				</el-select>&nbsp;
				<el-select v-model="query.chessSectType" placeholder="请选择棋派类型" style="width:200px">
					<el-option key="" label="请选择棋派类型" value=""></el-option>
					<el-option key="0" label="渠道和客户" value="0"></el-option>
					<el-option key="1" label="渠道" value="1"></el-option>
					<el-option key="2" label="客户" value="2"></el-option>
				</el-select>&nbsp;
				<el-checkbox v-model="query.toBeReminded" placeholder="待联系" style="padding:10px;">待联系</el-checkbox>
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
				:cell-style="{padding:4+'px'}"
				stripe
            >
                <el-table-column prop="name" label="公司名称"></el-table-column>
				<el-table-column prop="channelId" label="是否渠道" width="100">
					<template slot-scope="scope">
						<el-tag :type= "scope.row.channelId?'success':'info'" >{{scope.row.channelId?'是':'否'}}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="customerId" label="是否客户" width="100">
					<template slot-scope="scope">
						<el-tag :type= "scope.row.customerId?'success':'info'" >{{scope.row.customerId?'是':'否'}}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="trackName" label="跟踪人" width="120">
					<template slot-scope="scope">
						{{scope.row.trackName?scope.row.trackName:'无'}}
					</template>
				</el-table-column>
				<el-table-column prop="score" label="评分" width="100">
					<template slot-scope="scope">
						{{scope.row.score===0?'--':scope.row.score}}
					</template>
				</el-table-column>
				<el-table-column prop="coreSect" label="重点棋派" width="100">
					<template slot-scope="scope">
						<el-tag type= 'success' v-if=scope.row.coreSect>是</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="latestContactTime" label="最近联系时间" width="160">
					<template slot-scope="scope">
						{{scope.row.latestContactTime?scope.row.latestContactTime:'--'}}
					</template>
				</el-table-column>
				<el-table-column prop="createTime" label="创建时间" width="160"></el-table-column>
                <el-table-column label="操作" width="120" align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            @click="handleEdit(scope.$index, scope.row)"
							v-if="controll['edit']"
                        >编辑</el-button>
						<!--<el-button
                            type="text"
                            icon="el-icon-edit"
                            @click="handleScore(scope.$index, scope.row)"
							v-if="controll['score']"
                        >评分</el-button>-->
                    </template>
                </el-table-column>
            </el-table>
			<div class="record-a-d">
				<el-upload
					style="float:left"
					class="upload-demo mr10"
					accept=".xls,.xlsx"
					action= "/blob/chess-sect/import-sect"
					:on-success="uploadSuccess"
					:show-file-list = "false"
					v-if="controll['import']"
					list-type="picture">
					<el-button size="small" type="primary" icon="el-icon-folder-add" v-if="controll['import']">导入棋派</el-button>
				</el-upload>
				<el-button
					style="float:left"
                    type="primary"
                    icon="el-icon-lx-add"
                    class="handle-del mr10"
					v-if="controll['add']"
                    @click="handleAdd"
                >添加记录</el-button>
			</div>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false :title="title" :visible.sync="editVisible" width="30%">
            <el-form ref="form" :model="form" label-width="80px" :rules="rules">
				<el-form-item label="公司名称" prop="name">
                    <el-input v-model="form.name"></el-input>
                </el-form-item>
				<el-form-item label="重点棋派" prop="coreSect">
                    <el-switch v-model="form.coreSect"></el-switch>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit" v-prevent-re-click>确 定</el-button>
            </span>
        </el-dialog>
		
		<el-dialog v-dialogDrag :close-on-click-modal=false title="预览" :visible.sync="previewVisible" width="60%">
            <el-table
                :data="previewData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
				:cell-style="{padding:4+'px'}"
				height="500px"
				stripe
            >
                <el-table-column prop="sectName" label="棋派名称"></el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
				<el-button @click="previewVisible = false">取 消</el-button>
				<el-button type="primary" @click="save">保 存</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { getControll } from '../../../utils/controlls';
import { fetchChessSectData, saveChessSect, getChessSect, saveChessSectScore, saveChessSectBatch } from '../../../api/index';
export default {
    name: 'chess-sect',
    data() {
        return {
            query: {
				from:this.$route.query.from,
                code: '',
                name: '',
                pageNum: 1,
                pageSize: 10
            },
            tableData: [],
            editVisible: false,
            pageTotal: 0,
            form: {},
            idx: -1,
			title:"",
			isDisabled:false,
			previewVisible:false,
			rules: {
                name: [{ required: true, message: '公司名称不能为空', trigger: 'blur' }]
            },
			controll:{}
        };
    },
    created() {
		this.controll = getControll("chess-sect");
		if (this.query.from == 'track') {
			this.$set(this.query, "toBeReminded", true);
			this.$set(this.query, "chessSectType", "2");
		}
        this.getData();
    },
    methods: {
        // 获取 easy-mock 的模拟数据
        getData() {
            fetchChessSectData(this.query).then(res => { 
				if (res.code == 0 ) {
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
            });
        },
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageNum', 1);
			this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deleteChessSect([row.id]).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
                })
                .catch(() => {});
        },
		//添加操作
		handleAdd() {
			this.form = {};
			this.title = "添加新纪录";
			this.isDisabled = false;
			this.editVisible = true;
		},
        // 编辑操作
        handleEdit(index, row) {
            this.idx = index;
            //this.form = row;
			this.title = "编辑";
			this.isDisabled = true;
			getChessSect(row.id).then(res => {
				if (res.code == 0) {
					this.form = res.data;
					this.editVisible = true;
				} else {
					this.$message.error(`获取数据详情失败！` + res.message);
				}
			})
        },
        // 保存编辑
        saveEdit() {
			this.$refs.form.validate(valid => {
				if (valid) {
					saveChessSect(this.form).then(res => {
						if (res.code == 0) {
							this.$message.success('保存成功！');
							this.editVisible = false;
							this.getData();
						} else {
							this.$message.error(`保存失败！` + res.message);
						}
					})
				} else {
					this.$message.error('数据信息不完整！');
				}
			});
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
			this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
		uploadSuccess(response, file, fileList) {
			if (response.code == 0 ) {
				this.previewData = response.data.obj;
				this.uuid = response.data.uuid;
				this.previewVisible = true;
			} else {
				this.$message.error(response.message);
			}
		},
		save() {
			saveChessSectBatch(this.uuid).then(res => {
				if (res.code == 0) {
					this.$message.success('保存成功！');
					this.previewVisible = false;
					this.getData();
				} else {
					this.$message.error(`保存失败！` + res.message);
				}
			});
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}
</style>
